import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppService } from '../app/app.service';
import { Constants } from 'app/components/utils/Constants';
import { ChangePassword } from 'app/models/changePassword';
import { StockDetailRequestModel } from 'app/models/stock-detail-request-model';
import { ChangeTokenPassword } from 'app/models/change-token-password';
import { ConfigGlobalModel } from 'app/models/config-global-model';
import { LandingPageConfig } from 'app/pages/landing-page/landing-page.models';
import { SupportedLanguage } from '../language/languages';

@Injectable({
  providedIn: 'root'
})
export class RestService {

    constructor(
        private http: HttpClient,
        private appService: AppService) {
                 
    }

    getConfigurationGlobal(): Observable<ConfigGlobalModel> {
        return this.http.get<ConfigGlobalModel>(this.appService.servidor+'/public/configuration');
    }
    getLandingPage(language: SupportedLanguage): Observable<LandingPageConfig> {
        return this.http.get<LandingPageConfig>(this.appService.servidor+'/public/landingPage?language='+language.toUpperCase());
    }
    getLocation(locationCode:string): Observable<any> {
        return this.http.get(this.appService.servidor+'/reserve/locations/'+locationCode);
    }
    searchUsers(filters:string): Observable<any> {
        return this.http.get(this.appService.servidor+'/admin/users/search?'+filters);
    }
    changePassword(changePassword: ChangePassword): Observable<any> {
        return this.http.post(this.appService.servidor+'/admin/changePassword', changePassword);
    }
    changePasswordOrder(uuid: string, passowds:any): Observable<any> {
        return this.http.post(this.appService.servidor+'/user/reserves/changePin/'+uuid, passowds);
    }
    //Invoice
    getInvoiceBase64(invoiceNumber: string): Observable<any> {
        return this.http.get(`${this.appService.servidor}/admin/invoices/${invoiceNumber}/file`);
    }
    getInvoiceBase64User(invoiceNumber: string): Observable<any> {
        return this.http.get(`${this.appService.servidor}/user/invoice/download/${invoiceNumber}`);
    }
    resendEmailUser(paymentUuid: any): Observable<any> {
        return this.http.get(this.appService.servidor+'/reserve/resendEmail/'+paymentUuid);
    }
    getStockLockers(): Observable<any> {
        return this.http.get(this.appService.servidor+'/reserve/stock', {context: new HttpContext().set(Constants.SPINNER, false)});
    }
    getProfile(): Observable<any> {
        return this.http.get(this.appService.servidor+'/user/profile', {context: new HttpContext().set(Constants.REDIRECT, false)});
    }
    updateProfile(profile: any): Observable<any> {
        return this.http.post<any>(this.appService.servidor+'/user/profile', profile);
    }
    login(form: any): Observable<any> {
        return this.http.post(this.appService.servidor+'/auth/signin', form);
    }
    registro(form: any): Observable<any> {
        return this.http.post(this.appService.servidor+'/auth/signup', form);
    }
    forgotPassword(email: string): Observable<any> {
        return this.http.get(this.appService.servidor+'/auth/user/forgotPassword/'+email);
    }
    resetPassword(changeTokenPassword: ChangeTokenPassword): Observable<any> {
        return this.http.post(this.appService.servidor+'/auth/user/resetPassword', changeTokenPassword);
    }
    loginAs(username: string): Observable<any> {
        return this.http.post(this.appService.servidor+'/admin/loginAs/'+username, {});
    }
    checkoutCardStripe(cartRequest: any): Observable<any> {
        return this.http.post(this.appService.servidor+'/payment/checkout/card/stripe', cartRequest);
    }
    checkoutCardMypost(cartRequest: any): Observable<any> {
        return this.http.post(this.appService.servidor+'/payment/checkout/card/mypos', cartRequest);
    }
    checkoutCardPaypal(cartRequest: any): Observable<any> {
        return this.http.post(this.appService.servidor+'/payment/checkout/card/paypal', cartRequest);
    }
    cancelCheckoutCard(paymentUuid: any): Observable<any> {
        return this.http.post(this.appService.servidor+'/payment/checkout/card/cancel/'+paymentUuid, {});
    }
    cancelSubscription(paymentUuid: any): Observable<any> {
        return this.http.post(this.appService.servidor+'/payment/checkout/subscription/cancel/'+paymentUuid, {});
    }
    calculatorStep2(stockDetailRequestModel: StockDetailRequestModel): Observable<any> {
        return this.http.post(this.appService.servidor+'/reserve/calculator/step2', stockDetailRequestModel, {context: new HttpContext().set(Constants.SPINNER, false)});
    }
    calculatorStep3(stockDetailRequestModel: any): Observable<any> {
        return this.http.post(this.appService.servidor+'/reserve/calculator/step3', stockDetailRequestModel, {context: new HttpContext().set(Constants.SPINNER, false)});
    }
    infoCart(cartRequest: any): Observable<any> {
        return this.http.post(this.appService.servidor+'/reserve/infocart', cartRequest);
    }
    getResumenOnline(paymentUuid: string): Observable<any> {
        return this.http.get(this.appService.servidor+'/reserve/getResumenOnline/' + paymentUuid, {context: new HttpContext().set(Constants.SPINNER, false)});
    }
    validateDiscount(cartRequest: any): Observable<any> {
        return this.http.post(this.appService.servidor+'/payment/validateDiscount', cartRequest);
    }
    getMyReserves(): Observable<any> {
        return this.http.get(this.appService.servidor+'/user/reserves?filters=status;EQUALS;OPEN&sort=createdAt,desc');
    }
    /* Commission */
    getMyCommissions(): Observable<any> {
        return this.http.get(this.appService.servidor+'/commission/myCommissions?sort=createdAt,desc');
    }
    commissionTransfer(): Observable<any> {
        return this.http.post(this.appService.servidor+'/commission/commissionTransfer', {});
    }
    getCommissionLink(): Observable<any> {
        return this.http.get(this.appService.servidor+'/commission/commissionLink');
    }
    /* Commission */
    getMyWallet(): Observable<any> {
        return this.http.get(this.appService.servidor+'/user/myWallet');
    }
    buyMyDiscountCoupon(locationId: number, code: string): Observable<any> {
        return this.http.post(this.appService.servidor+'/user/buyMyDiscountCoupon', {locationId: locationId, code:code});
    }
    getMyCoupons(): Observable<any> {
        return this.http.get(this.appService.servidor+'/user/myCoupons');
    }
    getWalletMovements(): Observable<any> {
        return this.http.get(this.appService.servidor+'/user/myWalletMovements?sort=createdAt,desc');
    }
    loginApp(form:any): Observable<any> {
        return this.http.post(this.appService.servidor+'/admin/loginapp', form);
    }
    paymentCancel(paymentUuid:string): Observable<any> {
        return this.http.post(`${this.appService.servidor}/admin/payments/${paymentUuid}/cancellation`, {});
    }
    redirection(url:string): Observable<any> {
        return this.http.get(this.appService.servidor+'/l/'+url);
    }

}
